import React from 'react'

// components
import { BodyHead, BodyTitle } from '../../components/bakery/styleds'
import Mint from '../BakeryArtworks/components/Mint'

// constants
import { mintInfo, mintType } from '../../constants/artwork'
import { MARKETTYPE } from '../../constants/bakery/nft'

export default function MintArtworks() {
  return (
    <>
      <BodyHead>
        <BodyTitle fontSize={32} fontWeight={700} marginTop={64}>
          { mintType.title[MARKETTYPE.RACANFT] }
        </BodyTitle>
      </BodyHead>
      <Mint info={mintInfo} type={MARKETTYPE.RACANFT}></Mint>
     </>
  )
}
